import axios from "@/common/http.js";
import { TaiyuanForeignLanSchoolId } from "@/common/constant";
import Vue from "vue";
function timeConvert(timestamp, num) {
  //num:0 YYYY-MM-DD  num:1  YYYY-MM-DD hh:mm:ss // timestamp:时间戳
  timestamp = timestamp + "";
  timestamp = timestamp.length == 10 ? timestamp * 1000 : timestamp;
  var date = new Date(timestamp);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? "0" + m : m;
  var d = date.getDate();
  d = d < 10 ? "0" + d : d;
  var h = date.getHours();
  h = h < 10 ? "0" + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? "0" + minute : minute;
  second = second < 10 ? "0" + second : second;
  if (num == 0) {
    return m + "-" + d + " " + h + ":" + minute;
  } else if (num == 1) {
    return y + "-" + m + "-" + d;
  } else {
    return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
  }
}
//Array.some() 找到数组内是否有指定
function someobj(moods, val) {
  return moods.some(mood => mood == val);
}
//部门资源
function setroot(data, userid, ismanager) {
  let rootuid = JSON.parse(window.localStorage.getItem("rules"));
  for (let i = 0; i < data.length; i++) {
    if (data[i].editor == window.localStorage.getItem("userid")) {
      //自己
      someobj(rootuid, 42)
        ? (data[i].canread = true)
        : (data[i].canread = false); //可读
      someobj(rootuid, 43)
        ? (data[i].canedit = true)
        : (data[i].canedit = false); //可编辑
      someobj(rootuid, 44)
        ? (data[i].candelete = true)
        : (data[i].candelete = false); //删除
      someobj(rootuid, 45)
        ? (data[i].candownload = true)
        : (data[i].candownload = false); //可下载
      someobj(rootuid, 46)
        ? (data[i].canmove = true)
        : (data[i].canmove = false); //可移动
      someobj(rootuid, 47)
        ? (data[i].canrechristen = true)
        : (data[i].canrechristen = false); //可重命名
      someobj(rootuid, 48)
        ? (data[i].cansort = true)
        : (data[i].cansort = false); //可排序
      someobj(rootuid, 49) ? (data[i].cannew = true) : (data[i].cannew = false); //可上传/新建
    } else {
      // 操作他人文件
      someobj(rootuid, 50)
        ? (data[i].canread = true)
        : (data[i].canread = false); //可读
      someobj(rootuid, 51)
        ? (data[i].canedit = true)
        : (data[i].canedit = false); //可编辑
      someobj(rootuid, 52)
        ? (data[i].candelete = true)
        : (data[i].candelete = false); //删除
      someobj(rootuid, 53)
        ? (data[i].candownload = true)
        : (data[i].candownload = false); //可下载
      someobj(rootuid, 54)
        ? (data[i].canmove = true)
        : (data[i].canmove = false); //可移动
      someobj(rootuid, 55)
        ? (data[i].canrechristen = true)
        : (data[i].canrechristen = false); //可重命名
      someobj(rootuid, 56)
        ? (data[i].cansort = true)
        : (data[i].cansort = false); //可排序
      someobj(rootuid, 57) ? (data[i].cannew = true) : (data[i].cannew = false); //可上传/新建
      // 文件操作
      // 编辑 0仅自己可编辑,1本部门指定人员可编辑,2本部门人员均可编辑,3全组织人员可编辑
      // 可见 0为都不可见(已删除到回收站),1为仅自己可见,2为均可见,3部分人可见
      // 下载 0仅自己下载 1指定人员下载 2开放下载 downloadable
      switch (data[i].downloadable) {
        case 0:
          data[i].candownload = false;
          break;
        case 1:
          someobj(
            data[i].downloadid.split(","),
            window.localStorage.getItem("userid")
          )
            ? (data[i].candownload = true)
            : (data[i].candownload = false);
          break;
        case 2:
          data[i].candownload = true;
          break;
      }
      //编辑 0仅自己可编辑,1本部门指定人员可编辑,2本部门人员均可编辑,3全组织人员可编辑
      switch (data[i].editdic) {
        case 0:
          data[i].canedit = false;
          break;
        case 1:
          someobj(
            data[i].editids.split(","),
            window.localStorage.getItem("userid")
          )
            ? (data[i].canedit = true)
            : (data[i].canedit = false);
          break;
        case 2:
          data[i].canedit = true;
          break;
        case 3:
          data[i].canedit = true;
          break;
      }
      // data[i].type=='text'?'':data[i].canupload==0?:'';
      data[i].canmove = false;
      data[i].type == "text"
        ? ""
        : data[i].canupload == 0
        ? (data[i].cannew = false)
        : "";
      // 强制文件操作权限
      if (ismanager == 1) {
        data[i].canread = true; //可读
        data[i].canedit = true; //可编辑
        data[i].candelete = true; //删除
        data[i].candownload = true; //可下载
        data[i].canmove = true; //可移动
        data[i].canrechristen = true; //可重命名
        data[i].cansort = true; //可排序
        data[i].cannew = true; //可上传/新建
      } else {
        someobj(rootuid, 58) ? (data[i].canread = true) : ""; //可读
        someobj(rootuid, 59) ? (data[i].canedit = true) : ""; //可编辑
        someobj(rootuid, 60)
          ? (data[i].candelete = true)
          : (data[i].candelete = false); //删除
        someobj(rootuid, 61) ? (data[i].candownload = true) : ""; //可下载
        someobj(rootuid, 62) ? (data[i].canmove = true) : ""; //可移动
        someobj(rootuid, 63)
          ? (data[i].canrechristen = true)
          : (data[i].canrechristen = false); //可重命名
        someobj(rootuid, 64) ? (data[i].cansort = true) : ""; //可排序
        someobj(rootuid, 65) ? (data[i].cannew = true) : ""; //可上传/新建
      }
    }
  }
  return data;
}
// 共享文件
function setshareroot(data, userid) {
  let rootuid = JSON.parse(window.localStorage.getItem("rules"));
  for (let i = 0; i < data.length; i++) {
    if (data[i].editor == window.localStorage.getItem("userid")) {
      //自己
      someobj(rootuid, 18)
        ? (data[i].canread = true)
        : (data[i].canread = false); //可读
      someobj(rootuid, 19)
        ? (data[i].canedit = true)
        : (data[i].canedit = false); //可编辑
      someobj(rootuid, 20)
        ? (data[i].candelete = true)
        : (data[i].candelete = false); //删除
      someobj(rootuid, 21)
        ? (data[i].candownload = true)
        : (data[i].candownload = false); //可下载
      someobj(rootuid, 22)
        ? (data[i].canmove = true)
        : (data[i].canmove = false); //可移动
      someobj(rootuid, 23)
        ? (data[i].canrechristen = true)
        : (data[i].canrechristen = false); //可重命名
      someobj(rootuid, 24)
        ? (data[i].cansort = true)
        : (data[i].cansort = false); //可排序
      someobj(rootuid, 25) ? (data[i].cannew = true) : (data[i].cannew = false); //可上传/新建
    } else {
      // 操作他人文件
      someobj(rootuid, 26)
        ? (data[i].canread = true)
        : (data[i].canread = false); //可读
      someobj(rootuid, 27)
        ? (data[i].canedit = true)
        : (data[i].canedit = false); //可编辑
      someobj(rootuid, 28)
        ? (data[i].candelete = true)
        : (data[i].candelete = false); //删除
      someobj(rootuid, 29)
        ? (data[i].candownload = true)
        : (data[i].candownload = false); //可下载
      someobj(rootuid, 30)
        ? (data[i].canmove = true)
        : (data[i].canmove = false); //可移动
      someobj(rootuid, 31)
        ? (data[i].canrechristen = true)
        : (data[i].canrechristen = false); //可重命名
      someobj(rootuid, 32)
        ? (data[i].cansort = true)
        : (data[i].cansort = false); //可排序
      someobj(rootuid, 33) ? (data[i].cannew = true) : (data[i].cannew = false); //可上传/新建
      // 文件操作
      // 编辑 0仅自己可编辑,1本部门指定人员可编辑,2本部门人员均可编辑,3全组织人员可编辑
      // 可见 0为都不可见(已删除到回收站),1为仅自己可见,2为均可见,3部分人可见
      // 下载 0仅自己下载 1指定人员下载 2开放下载 downloadable
      switch (data[i].downloadable) {
        case 0:
          data[i].candownload = false;
          break;
        case 1:
          someobj(
            data[i].downloadid.split(","),
            window.localStorage.getItem("userid")
          )
            ? (data[i].candownload = true)
            : (data[i].candownload = false);
          break;
        case 2:
          data[i].candownload = true;
          break;
      }
      //编辑 0仅自己可编辑,1本部门指定人员可编辑,2本部门人员均可编辑,3全组织人员可编辑
      switch (data[i].editdic) {
        case 0:
          data[i].canedit = false;
          break;
        case 1:
          someobj(
            data[i].editids.split(","),
            window.localStorage.getItem("userid")
          )
            ? (data[i].canedit = true)
            : (data[i].canedit = false);
          break;
        case 2:
          data[i].canedit = true;
          break;
        case 3:
          data[i].canedit = true;
          break;
      }
      data[i].canmove = false;
      data[i].type == "text"
        ? ""
        : data[i].canupload == 0
        ? (data[i].cannew = false)
        : "";
      // 强制文件操作权限
      someobj(rootuid, 34) ? (data[i].canread = true) : ""; //可读
      someobj(rootuid, 35) ? (data[i].canedit = true) : ""; //可编辑
      someobj(rootuid, 36)
        ? (data[i].candelete = true)
        : (data[i].candelete = false); //删除
      someobj(rootuid, 37) ? (data[i].candownload = true) : ""; //可下载
      someobj(rootuid, 38) ? (data[i].canmove = true) : ""; //可移动
      someobj(rootuid, 39)
        ? (data[i].canrechristen = true)
        : (data[i].canrechristen = false); //可重命名
      someobj(rootuid, 40) ? (data[i].cansort = true) : ""; //可排序
      someobj(rootuid, 41) ? (data[i].cannew = true) : ""; //可上传/新建
    }
  }
  return data;
}
var actions = {
  // 获取全部部门列表
  async getdepartmentlist({ commit, state }, schoolid) {
    let { code, data, msg } = await axios({
      url: "index/department.Dept/getDepList",
      method: "get",
      params: {
        schoolid: schoolid
        // page:1,
        // pagesize:10
      }
    });
    if (code == "10001" && data.length > 0) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].userid != null && data[i].userid != "") {
          if (data[i].userid.indexOf(",") != -1) {
            data[i].userid = data[i].userid.split(",");
            data[i].nickname = data[i].nickname.split(",");
          } else {
            data[i].userid = data[i].userid.split(" ");
            data[i].nickname = data[i].nickname.split(" ");
          }
        }
      }
      commit("sethasdepartall", data);
    } else if (code == "10001" && data.length == 0) {
      commit("sethasdepartall", []);
    }
  },
  // 获取用户部门信息
  async getuserDepatment({ commit, state }, { userid, type }) {
    let { code, data } = await axios({
      url: "index/user.User/getUserDept",
      method: "get",
      params: {
        userid: userid || window.localStorage.getItem("userid"),
        schoolid: window.localStorage.getItem("schoolid")
      }
    });
    if (code == "10001" && data.length > 0) {
      commit("sethasdepart", data);
      if (type == "setanquan") return false;
      for (let i = 0; i < data.length; i++) {
        if (window.localStorage.getItem("nowPar") != null) {
          if (window.localStorage.getItem("nowPar") == data[i].deptid) {
            state.nodepartitle == ""
              ? commit("setnodepartitle", data[i].deptid)
              : "";
            state.nodepartinfo == ""
              ? commit("setdedata", { data: data[i], key: "nodepartinfo" })
              : "";
            break;
          }
        } else {
          if (data[i].default == 1) {
            state.nodepartitle == ""
              ? commit("setnodepartitle", data[i].deptid)
              : "";
            state.nodepartinfo == ""
              ? commit("setdedata", { data: data[i], key: "nodepartinfo" })
              : "";
            break;
          } else {
            state.nodepartitle == ""
              ? commit("setnodepartitle", data[0].deptid)
              : "";
            state.nodepartinfo == ""
              ? commit("setdedata", { data: data[0], key: "nodepartinfo" })
              : "";
          }
        }
      }
    } else if (code == "10001" && data.length == 0) {
      commit("sethasdepart", []);
      if (type == "setanquan") return false;
      state.nodepartitle == "" ? commit("setnodepartitle", "共享文件") : "";
      state.nodepartinfo == ""
        ? commit("setdedata", { data: "empty", key: "nodepartinfo" })
        : "";
    } else {
      console.log(code, data);
    }
  },
  // 获取部门下资源
  getdepartmentziyuan(
    { commit, state },
    {
      deptid,
      schoolid,
      page = 1,
      pagesize = 20,
      order,
      pid,
      userid,
      fileType
    } = {}
  ) {
    commit("setdedata", {
      data: true,
      key: "deloading"
    });
    const newSchoolId = schoolid || window.localStorage.getItem("schoolid");
    let params = {
      deptid: deptid || state.nodepartitle,
      schoolid: schoolid || window.localStorage.getItem("schoolid"),
      page: page || state.depage,
      pagesize: pagesize || state.depagesize,
      pid: "",
      userid: userid || window.localStorage.getItem("userid"),
      order: order || state.order
    };
    pid != undefined ? (params.pid = String(pid)) : (params.pid = state.pid);

    if (state.fileType && newSchoolId === String(TaiyuanForeignLanSchoolId)) {
      params.file_type = state.fileType;
    }
    if (fileType && String(newSchoolId) === String(TaiyuanForeignLanSchoolId)) {
      params.file_type = fileType;
    }
    console.log("文件类型：", params.file_type);
    axios({
      url: "index/department.Dept/getDeptFile",
      method: "get",
      params: params
    }).then(res => {
      if (res.code == "10001" && res.data.length > 0) {
        let newdata = res.data;
        newdata = setroot(
          res.data,
          window.localStorage.getItem("userid"),
          state.nodepartinfo.ismanager
        );

        // window.localStorage.getItem('rules').length>0?newdata=setroot(res.data,userid):''
        for (let i = 0; i < newdata.length; i++) {
          newdata[i].adtime = timeConvert(newdata[i].addtime);
        }
        commit("setdedata", {
          data: newdata,
          key: "deresour"
        });
        commit("setdedata", {
          data: res.info || 0,
          key: "detotal"
        });
      } else if (res.code == "10001" && res.data.length == 0) {
        commit("setdedata", {
          data: [],
          key: "deresour"
        });
        commit("setdedata", {
          data: 0,
          key: "detotal"
        });
      }
      if (page != undefined) {
        commit("setData", {
          data: page,
          field: "depage"
        });
      }
      commit("setdedata", {
        data: false,
        key: "deloading"
      });
    });
  },
  //搜索部门下资源
  searchgetdepartmentziyuan(
    { commit, state },
    {
      deptid,
      schoolid,
      page = 1,
      pagesize = 20,
      pid,
      userid,
      type,
      content
    } = {}
  ) {
    commit("setdedata", {
      data: true,
      key: "deloading"
    });
    const newSchoolId = schoolid || window.localStorage.getItem("schoolid");
    let params = {
      userid: userid || window.localStorage.getItem("userid"), //
      schoolid: newSchoolId, //
      title: content || state.searchcontent, //	string	搜索内容	是	否
      departmentid: deptid || state.nodepartitle, //	int	部门id	是	否
      pid: "", //	int	层级id	是	否
      type: type || state.select, //	int	搜索类型	是	否	1上传者 2文件名
      page: page || state.depage, //	int		是	否
      size: pagesize || state.depagesize, //	int		是	否
      share: 0 //
    };
    pid != undefined ? (params.pid = String(pid)) : (params.pid = state.pid);
    console.log(state.fileType, newSchoolId, TaiyuanForeignLanSchoolId);
    if (
      state.fileType &&
      String(newSchoolId) === String(TaiyuanForeignLanSchoolId)
    ) {
      params.file_type = state.fileType;
    }
    console.log(params);
    axios({
      url: "index/department.Dept/search",
      method: "get",
      params: params
    }).then(res => {
      if (res.code == "10001" && res.data.length > 0) {
        let newdata = res.data;
        // console.log(JSON.parse(window.localStorage.getItem('rules')))
        // return false
        newdata = setroot(
          res.data,
          window.localStorage.getItem("userid"),
          state.nodepartinfo.ismanager
        );

        // window.localStorage.getItem('rules').length>0?newdata=setroot(res.data,userid):''
        for (let i = 0; i < newdata.length; i++) {
          newdata[i].adtime = timeConvert(newdata[i].addtime);
          newdata[i].fileid = newdata[i].id;
        }
        commit("setdedata", {
          data: newdata,
          key: "deresour"
        });
        commit("setdedata", {
          data: res.info || 0,
          key: "detotal"
        });
      } else if (res.code == "10001" && res.data.length == 0) {
        commit("setdedata", {
          data: [],
          key: "deresour"
        });
        commit("setdedata", {
          data: 0,
          key: "detotal"
        });
      }
      if (page != undefined) {
        commit("setData", {
          data: page,
          field: "depage"
        });
      }
      commit("setdedata", {
        data: false,
        key: "deloading"
      });
    });
  },
  // 获取部门下成员
  async getdepartusers(
    { commit, state },
    { userid, deptid, nickname, type = "old" } = {}
  ) {
    let param = {
      userid: userid || window.localStorage.getItem("userid"),
      deptid: deptid || state.nodepartitle
    };
    if (nickname != undefined) {
      param.nickname = nickname;
    }
    let { code, data, info } = await axios({
      url: "index/department.Dept/getDeptUser",
      method: "get",
      params: param
    });
    if (type == "old") {
      if (code == "10001" && data.length > 0) {
        commit("setdedata", {
          data: data,
          key: "departmentuser"
        });
      } else {
        commit("setdedata", {
          data: "empty",
          key: "departmentuser"
        });
      }
    } else {
      if (code == "10001" && data.length > 0) {
        commit("setdedata", {
          data: data,
          key: "systemdeluser"
        });
      } else {
        commit("setdedata", {
          data: "empty",
          key: "systemdeluser"
        });
      }
    }
    commit("setdedata", {
      data: false,
      key: "canup"
    });
  },
  // 获取部门下成员
  getOrderdepartusers({ commit, state }, { userid, deptid } = {}) {
    let data = {
      userid: userid || window.localStorage.getItem("userid"),
      deptid: deptid
    };
    axios({
      url: "index/department.Dept/getAllDeptUser",
      method: "get",
      params: data
    })
      .then(({ code, data, info }) => {
        if (code == "10001" && data != null) {
          commit("setdedata", {
            data: data,
            key: "systemdeluser"
          });
        } else {
          commit("setdedata", {
            data: "empty",
            key: "systemdeluser"
          });
        }
      })
      .catch(err => {});
  },

  //设定权限获取成员
  getsetusers({ commit, state }, { userid, deptid } = {}) {
    let data = {
      userid: userid || window.localStorage.getItem("userid"),
      deptid: deptid
    };
    axios({
      url: "index/department.Dept/getAllDeptUser",
      method: "get",
      params: data
    })
      .then(({ code, data, info }) => {
        if (code == "10001" && data != null) {
          commit("setdedata", {
            data: data,
            key: "setusers"
          });
        } else {
          commit("setdedata", {
            data: "empty",
            key: "setusers"
          });
        }
      })
      .catch(err => {});
  },

  //获取部门列表
  // treeLevelDept({commit,state},schoolid){
  // 	axios({
  // 		url:'index/department.Dept/treeLevelDept',
  // 		method:'get',
  // 		params:data,
  // 	}).then(({code,data,info})=>{
  // 		console.log(code,data,info)
  // 	}).catch(err=>{
  // 	})
  // },

  //--------------------------------------共享文件夹
  // 获取部门下资源
  async getshareziyuan(
    { commit, state },
    {
      deptid,
      schoolid,
      page = 1,
      pagesize = 30,
      order,
      pid,
      userid,
      fileType
    } = {}
  ) {
    commit("setdedata", {
      data: true,
      key: "shareloading"
    });
    console.log('获取部门资源', state.fileType)
    const newSchoolId = schoolid || window.localStorage.getItem("schoolid");
    let params = {
      schoolid: schoolid || window.localStorage.getItem("schoolid"),
      page: page || state.sharepage,
      pagesize: pagesize || state.sharepagesize,
      pid: "",
      userid: userid || window.localStorage.getItem("userid")
    };
    console.log("文件类型：", state.fileType);
    if (state.fileType && newSchoolId === String(TaiyuanForeignLanSchoolId)) {
      console.log("添加filetype", 'filetype');
      params.file_type = state.fileType;
    }
    if (fileType && newSchoolId === TaiyuanForeignLanSchoolId) {
      params.file_type = fileType;
    }
    console.log("action参数**---**获取共享文件列表", params);
    pid != undefined
      ? (params.pid = String(pid))
      : (params.pid = state.sharepid);
    let { code, data, info } = await axios({
      url: "index/department.Dept/getShareFile",
      method: "get",
      params: params
    });
    if (code == "10001") {
      let newdata = data;
      // console.log(JSON.parse(window.localStorage.getItem('rules')))
      // return false
      newdata = setshareroot(data, window.localStorage.getItem("userid"));
      for (let i = 0; i < newdata.length; i++) {
        newdata[i].adtime = timeConvert(newdata[i].addtime);
      }
      console.log("设置共享文件列表", newdata);
      commit("setdedata", {
        data: newdata,
        key: "shareresour"
      });
      commit("setdedata", {
        data: info || 0,
        key: "sharetotal"
      });
    } else {
      console.log("设置共享文件列表");
      commit("setdedata", {
        data: [],
        key: "shareresour"
      });
      commit("setdedata", {
        data: 0,
        key: "sharetotal"
      });
    }
    if (page != undefined) {
      commit("setData", {
        data: page,
        field: "sharepage"
      });
    }
    commit("setdedata", {
      data: false,
      key: "shareloading"
    });
  },
  // 搜索资源
  async searchgetshareziyuan(
    { commit, state },
    {
      deptid,
      schoolid,
      page = 1,
      pagesize = 30,
      pid,
      userid,
      type,
      content
    } = {}
  ) {
    console.log("搜索searchgetshareziyuan");
    commit("setdedata", {
      data: true,
      key: "shareloading"
    });
    const newSchoolId = schoolid || window.localStorage.getItem("schoolid");
    let params = {
      userid: userid || window.localStorage.getItem("userid"), //int	用户id	是	否
      schoolid: newSchoolId, //int	学校id	是	否
      title: content || state.sharesearchcontent, //string	搜索内容	是	否
      departmentid: 0, //int	部门id	是	否
      pid: pid || state.sharepid, //int	层级id	是	否
      type: type || shareselect, //	int	搜索类型	是	否	1上传者 2文件名
      page: page || state.sharepage, //	int		是	否
      size: pagesize || state.sharepagesize, //	int		是	否
      share: 1 //
    };
    pid != undefined
      ? (params.pid = String(pid))
      : (params.pid = state.sharepid);
    console.log(state.fileType, newSchoolId, TaiyuanForeignLanSchoolId);
    if (
      state.fileType &&
      String(newSchoolId) === String(TaiyuanForeignLanSchoolId)
    ) {
      params.file_type = state.fileType;
    }
    console.log(params);
    let { code, data, info } = await axios({
      url: "index/department.Dept/search",
      method: "get",
      params: params
    });
    if (code == "10001") {
      let newdata = data;
      // console.log(JSON.parse(window.localStorage.getItem('rules')))
      // return false
      newdata = setshareroot(data, window.localStorage.getItem("userid"));
      for (let i = 0; i < newdata.length; i++) {
        newdata[i].adtime = timeConvert(newdata[i].addtime);
      }
      console.log("设置共享文件夹列表");
      commit("setdedata", {
        data: newdata,
        key: "shareresour"
      });
      commit("setdedata", {
        data: info || 0,
        key: "sharetotal"
      });
    } else {
      console.log("设置共享文件夹列表");
      commit("setdedata", {
        data: [],
        key: "shareresour"
      });
      commit("setdedata", {
        data: 0,
        key: "sharetotal"
      });
    }
    if (page != undefined) {
      commit("setData", {
        data: page,
        field: "sharepage"
      });
    }
    commit("setdedata", {
      data: false,
      key: "shareloading"
    });
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/store/modules/department/action.js